import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Flex } from 'grid-styled';

const rotate360 = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

const LoaderWrapper = styled.div`
  svg {
    width: 40px;
    height: 40px;
    animation: ${rotate360} 1500ms linear infinite;
  }
`;

const BouncingLoader = styled.div`
  @keyframes bouncing-loader {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0.1;
      transform: translateY(-1rem);
    }
  }

  display: flex;
  justify-content: center;

  & > div {
    width: 1rem;
    height: 1rem;
    margin: 3rem 0.2rem;
    background: #8385aa;
    border-radius: 50%;
    animation: bouncing-loader 0.6s infinite alternate;
  }
  & > div:nth-child(2) {
    animation-delay: 0.2s;
  }
  & > div:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

class Loader extends React.Component {
  render() {
    return (
      <LoaderWrapper>
        {/* <Icon id="loading-icon" /> */}
        <Flex
          alignItems="center"
          justifyContent="center"
          style={{ height: '100%' }}
        >
          <BouncingLoader class="bouncing-loader">
            <div />
            <div />
            <div />
          </BouncingLoader>
        </Flex>
      </LoaderWrapper>
    );
  }
}

Loader.propTypes = {};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js